import classNames from "classnames";
import React from "react";
import { useEffect, useState } from "react";
import { isBrowser } from '../../core/detection';
import { detectBrowser, getUserAgent } from '../helpers/browserDetectionHelper';
import { supportsObjectFit } from '../../../../packages/ui/src/utils';
import { LinkContext, ReactRouterLink } from "../../core/atoms";
import { isFlagActive, FeatureFlag } from "../helpers/featureFlags";
import { useStyle } from "../helpers/useStyleHook";

interface Props {
  className: string;
}

/**
 * The root element of web and portal sites. 
 */
export const SiteRoot: React.FC<Props> = (props) => {
  const [isMounted, setMounted] = useState(false);
  useEffect(() => setMounted(isBrowser()), []);

  const browserClassNames = isMounted ? classNames(detectBrowser(getUserAgent()), {
    "has-object-fit": supportsObjectFit(),
    "no-object-fit": !supportsObjectFit(),
  }) : undefined;

  const className = classNames("site", props.className, browserClassNames);

  // #3387 We're trying out a new brand style for 2021.
  const isNewBrandActive = isFlagActive(FeatureFlag.SIMS_REBRAND_3387);
  useStyle("https://fonts.googleapis.com/css2?family=Playfair+Display:wght@800&display=swap", isNewBrandActive);
  const style = isMounted && isNewBrandActive ? {
    ["--font-heading"]: `"Playfair Display", serif`,
    ["--brand-accent"]: "#057F80",
    ["--brand-grey"]: "#E6D7CB",
    ["--brand-light-grey"]: "#F4F0ED",
  } as React.CSSProperties : undefined;

  return (
    <LinkContext.Provider value={{ Component: ReactRouterLink }}>
      <div className={className} style={style}>
        {props.children}
      </div>
    </LinkContext.Provider>
  )
};
